import React from 'react';
import styles from '../pages/UserDetailsPage.module.css';
import { updateUserDetails } from '../utils/api';

const UserInfo = ({ user, setUser, onImageClick, onSaveSuccess }) => {
    const handleStatusToggle = async (type, currentStatus) => {
        const newStatus = currentStatus === 'approved' ? 'pending' : 'approved';
        const field = type === 'KYC' ? 'kycStatus' : 'bankStatus';
        
        try {
            const res = await updateUserDetails(user._id, { [field]: newStatus });
            setUser(res.data);
            alert(`${type} status updated to ${newStatus} successfully!`);
            if (onSaveSuccess) {
                onSaveSuccess();
            }
        } catch (err) {
            console.error(`[Admin Frontend] Failed to update ${type} status`, err);
            alert(`Failed to update ${type} status`);
        }
    };

    return (
        <>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Name:</span>
                <span>{user.name}</span>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Email:</span>
                <span>{user.email}</span>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Mobile:</span>
                <span>{user.mobileNumber}</span>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Password:</span>
                <span>{user.password}</span>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>PAN Number:</span>
                <span>{user.panNumber}</span>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Aadhaar Number:</span>
                <span>{user.aadhaarNumber}</span>
            </div>
            <div className={styles['sub-heading']}>Bank Details</div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Account Number:</span>
                <span>{user.accountNumber}</span>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Bank Name:</span>
                <span>{user.bankName}</span>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>IFSC Code:</span>
                <span>{user.ifscCode}</span>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>KYC Status:</span>
                <span style={{ color: user.kycStatus === 'approved' ? 'green' : 'orange', fontWeight: 'bold' }}>
                    {user.kycStatus}
                </span>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Bank Status:</span>
                <span style={{ color: user.bankStatus === 'approved' ? 'green' : 'orange', fontWeight: 'bold' }}>
                    {user.bankStatus}
                </span>
            </div>

            <div className={styles.documents}>
                {user.panCard && (
                    <div className={styles.document}>
                        <strong>PAN Card</strong>
                        <img
                            src={user.panCard}
                            alt="PAN Card"
                            style={{ width: '100px', height: '100px', objectFit: 'cover', cursor: 'pointer' }}
                            onClick={() => onImageClick(user.panCard)}
                        />
                    </div>
                )}
                {user.aadhaarCard && (
                    <div className={styles.document}>
                        <strong>Aadhaar Card</strong>
                        <img
                            src={user.aadhaarCard}
                            alt="Aadhaar Card"
                            style={{ width: '100px', height: '100px', objectFit: 'cover', cursor: 'pointer' }}
                            onClick={() => onImageClick(user.aadhaarCard)}
                        />
                    </div>
                )}
            </div>
            
            <div className={styles['portfolio-actions']}>
                <button 
                    className={user.kycStatus === 'approved' ? styles['delete-button'] : styles['btn-approve']} 
                    onClick={() => handleStatusToggle('KYC', user.kycStatus)}
                >
                    {user.kycStatus === 'approved' ? 'Remove KYC' : 'Approve KYC'}
                </button>
                <button 
                    className={user.bankStatus === 'approved' ? styles['delete-button'] : styles['btn-approve']} 
                    onClick={() => handleStatusToggle('Bank', user.bankStatus)}
                >
                    {user.bankStatus === 'approved' ? 'Remove Bank' : 'Approve Bank'}
                </button>
            </div>
        </>
    );
};

export default UserInfo;
